import { useCallback, useContext } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { REDIRECT_PARAM } from '@namespace/common';
import { useLocation } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import { USER_ROLES, UserContext } from '@namespace/user';
import {
  getIsWidget,
  POST_MESSAGE_TYPES,
  usePostMessage
} from '@namespace/widget';

export const useRedirectToLogin = (isShowStreamForGuest: boolean) => {
  const [user] = useContext(UserContext);
  const { role } = user;
  const { push } = useHistory();
  const { login } = useGeneralRoutes();
  const { pathname } = useLocation();
  const { postMessage } = usePostMessage();

  return useCallback(() => {
    if (role !== USER_ROLES.USER && !isShowStreamForGuest) {
      if (getIsWidget()) {
        postMessage(POST_MESSAGE_TYPES.LOGIN, '');
      } else {
        push(`${login}?${REDIRECT_PARAM}${pathname}`);
      }

      return false;
    }

    return true;
  }, [login, pathname, push, role, isShowStreamForGuest]);
};
